import React from "react";
import { useUser } from "@clerk/nextjs";
import { Avatar, AvatarFallback, AvatarImage } from "../ui/avatar";

const PersonalAccountIcon = ({ className }: { className?: string }) => {
  const { user } = useUser();

  return (
    <Avatar className={className}>
      <AvatarImage src={user?.imageUrl} alt={user?.fullName || "User"} />
      <AvatarFallback className="bg-blue-500 text-white">
        {user?.firstName?.charAt(0) || user?.fullName?.charAt(0) || "U"}
      </AvatarFallback>
    </Avatar>
  );
};

export default PersonalAccountIcon;


